var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"mx-auto container-profile",attrs:{"outlined":""}},[_vm._t("header"),_vm._t("title"),_vm._t("subtitle"),_vm._t("body"),_vm._t("footer")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }